import React, { Component } from "react";
import Swal from "sweetalert2";
import {
  cancelItemReservation,
  getItemsReservation,
} from "../../../../../services/inventory/itemReservationService";
import CustomDataTable from "../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../partials/content/Illustration";
import DialogLayout from "../../../../../partials/content/DialogLayout";
import DirectPickForm from "./directPickForm";
import { Badge } from "react-bootstrap";
import ResponsiveEllipsis from "../../../../../partials/content/ResponsiveEllipsis";
import ReservationItemsPickup from "./reservationItemsPickup";
import BootstrapTooltip from "../../../../../partials/content/BootstrapTooltip";
import ItemsTransferForm from "../item-issue/items-transfer/itemsTransferForm";
import withGlobalData from "../../../common/withGlobalData";
class ItemsReservationList extends Component {
  state = {
    reload: this.props.globalData.reload,
    openDirectPickForm: false,
    openPickupItem: false,
    openItemsTransfer: false,
    reservations: [],
    itemReservationDetailColumn: [
      {
        header: "Document ID",
        field: "docID",
        type: "string",
      },
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };
  async getReservationsData(
    salesOrderID = 0,
    operationCardID = 0,
    warehouseID = 0,
    outletID = 0,
    orderType = "-"
  ) {
    const response = await getItemsReservation(
      salesOrderID,
      operationCardID,
      0,
      warehouseID,
      outletID,
      orderType
    );
    const { data } = response.data;
    this.setState({ reservations: data.itemsReservation });
  }
  componentDidMount() {
    const {
      salesOrderID = 0,
      operationCardID = 0,
      warehouseID: warehouseIDprop = 0,
      outletID: outletIDprop = 0,
      orderType = "-",
    } = this.props;

    let warehouseID = 0;
    let outletID = 0;
    warehouseID = parseInt(warehouseIDprop);
    if (warehouseID === 0) {
      const { warehouseID: warehouseIDparam = 0 } = this.props.match.params;
      warehouseID = parseInt(warehouseIDparam);
    }

    if (warehouseID === 0 && outletIDprop === 0) {
      const { outletID: outletIDparam = 0 } = this.props.match.params;
      outletID = parseInt(outletIDparam);
    }
    this.getReservationsData(
      salesOrderID,
      operationCardID,
      warehouseID,
      outletID,
      orderType
    );
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      const {
        salesOrderID = 0,
        operationCardID = 0,
        warehouseID: warehouseIDprop = 0,
        outletID: outletIDprop = 0,
        orderType = "-",
      } = this.props;

      let warehouseID = 0;
      let outletID = 0;
      warehouseID = parseInt(warehouseIDprop);
      if (warehouseID === 0) {
        const { warehouseID: warehouseIDparam = 0 } = this.props.match.params;
        warehouseID = parseInt(warehouseIDparam);
      }

      if (warehouseID === 0 && outletIDprop === 0) {
        const { outletID: outletIDparam = 0 } = this.props.match.params;
        outletID = parseInt(outletIDparam);
      }
      this.getReservationsData(
        salesOrderID,
        operationCardID,
        warehouseID,
        outletID,
        orderType
      );
      this.setState({ reload: globalData.reload });
    }
  }

  render() {
    const {
      openDirectPickForm,
      openPickupItem,
      openItemsTransfer,
      reservations,
      itemReservationDetailColumn,
    } = this.state;
    const {
      salesOrderID = 0,
      operationCardID = 0,
      warehouseID: warehouseIDprop = 0,
      customerID = 0,
      warehouseName = "",
      outletID = 0,
      orderType = "-",
    } = this.props;
    const columns = [];

    let warehouseID = 0;
    warehouseID = parseInt(warehouseIDprop);
    if (warehouseID === 0) {
      const { warehouseID: warehouseIDparam = 0 } = this.props.match.params;
      warehouseID = parseInt(warehouseIDparam);
    }

    columns.push(
      {
        header: "Reservation ID",
        field: "ID",
        body: null,
        sortable: true,
        filter: true,
      },
      {
        header: "Warehouse",
        field: "warehouse.warehouseName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis
              text={rowData.warehouse.warehouseName}
              maxLine="1"
            />
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
        hidden: salesOrderID > 0 ? false : true,
      },
      {
        header: "Reservation Status",
        field: "statusName",
        body: (rowData) => (
          <React.Fragment>
            <Badge
              variant={
                rowData.statusID === 1
                  ? "primary"
                  : rowData.statusID === 2
                  ? "info"
                  : rowData.statusID === 3 || rowData.statusID === 4
                  ? "success"
                  : null
              }
            >
              {rowData.statusName}
            </Badge>
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
      }
    );
    if (operationCardID === 0) {
      columns.push({
        header: "Request From",
        field: "docRef",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.docRef} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
      });
    }
    columns.push(
      {
        header: "Item Type",
        field: "itemTypeName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemTypeName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
        hidden: true,
      },
      {
        header: "Item Code",
        field: "itemCode",
        body: (rowData) => (
          <React.Fragment>
            {rowData.itemType > 0 ? (
              <span>
                <BootstrapTooltip title={rowData.itemTypeName}>
                  <span className="mr-2">
                    <i
                      className={
                        rowData.itemType === 1
                          ? "fas fa-boxes text-success"
                          : rowData.itemType === 2
                          ? "fas fa-tools text-primary"
                          : rowData.itemType === 3
                          ? "fas fa-building text-info"
                          : rowData.itemType === 4
                          ? "fas fa-boxes text-warning"
                          : rowData.itemType === 5
                          ? "fas fa-boxes text-danger"
                          : null
                      }
                    ></i>
                  </span>
                </BootstrapTooltip>
                <span>
                  <ResponsiveEllipsis
                    text={rowData.itemCode}
                    maxLine="1"
                    displayInline
                  />
                </span>
              </span>
            ) : (
              <React.Fragment>
                <ResponsiveEllipsis text={rowData.itemCode} maxLine="1" />
              </React.Fragment>
            )}
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
      },
      {
        header: "Item Name",
        field: "itemName",
        body: (rowData) => (
          <React.Fragment>
            <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
          </React.Fragment>
        ),
        sortable: true,
        filter: true,
      },
      {
        header: "Quantity",
        field: "qty",
        body: (rowData) => (
          <div>
            {rowData.qty} {rowData.uom.uom}
          </div>
        ),
        sortable: true,
        filter: true,
      },
      {
        header: "Unit",
        field: "uom.uom",
        body: null,
        sortable: true,
        filter: true,
        hidden: true,
      },
      {
        header: "Batch ID",
        field: "batchID",
        body: null,
        sortable: true,
        filter: true,
      },
      {
        header: "Actions",
        body: (rowData) => (
          <React.Fragment>
            {rowData.statusID < 3 ? (
              <BootstrapTooltip title="Delete Items Reservation">
                <button
                  type="button"
                  onClick={() => {
                    this.handleCancelItemsReservation(rowData);
                  }}
                  className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </BootstrapTooltip>
            ) : null}
          </React.Fragment>
        ),
        sortable: false,
      }
    );
    return (
      <React.Fragment>
        {reservations.length ? (
          <React.Fragment>
            <CustomDataTable
              data={reservations}
              dataDetailColumns={itemReservationDetailColumn}
              onRefreshData={() => {
                const { salesOrderID = 0, outletID = 0 } = this.props;
                this.getReservationsData(
                  salesOrderID,
                  operationCardID,
                  warehouseID,
                  outletID,
                  orderType
                );
              }}
              buttons={[
                {
                  name: "Items Pickup",
                  onClick: () => {
                    this.setState({ openPickupItem: true });
                  },
                  icon: "fas fa-hand-spock",
                  color: "primary",
                },
                {
                  name: "Items Transfer",
                  onClick: () => {
                    this.setState({ openItemsTransfer: true });
                  },
                  icon: "fas fa-truck",
                  color: "primary",
                },
              ]}
              columns={columns}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Illustration
              imageSource="INVIFO Procurement.png"
              description="Hooray! You're ready to have Items Reservation inside this warehouse!"
              guidance="Hint: once the Requested Items has been prepared and ready to be picked up, it will be displayed here"
              descriptionLeftIcon="fas fa-info-circle kt-font-success"
              size="md"
            ></Illustration>
          </React.Fragment>
        )}
        <DialogLayout
          open={openItemsTransfer}
          title="Items Transfer Form"
          onCloseDialog={() => {
            this.setState({ openItemsTransfer: false });
          }}
          maxWIdth="lg"
        >
          <ItemsTransferForm
            accessedFrom="RSV"
            warehouse={{ ID: warehouseID, warehouseName }}
            onCloseDialog={() => {
              this.setState({ openItemsTransfer: false });
            }}
            onConfirmSave={() => {
              this.getReservationsData(
                salesOrderID,
                operationCardID,
                warehouseID,
                outletID,
                orderType
              );
              this.setState({ openItemsTransfer: false });
            }}
          />
        </DialogLayout>
        <DialogLayout
          open={openDirectPickForm}
          title="Direct Pick Form"
          onCloseDialog={this.handleCloseDirectPickForm}
          maxWIdth="md"
        >
          <DirectPickForm
            warehouseID={warehouseID}
            salesOrderID={salesOrderID}
            customerID={customerID}
            warehouseName={warehouseName}
            onConfirmSave={() => {
              this.getReservationsData(
                salesOrderID,
                operationCardID,
                warehouseID,
                outletID,
                orderType
              );
              this.handleCloseDirectPickForm();
            }}
            onCloseDialog={this.handleCloseDirectPickForm}
          />
        </DialogLayout>
        <DialogLayout
          open={openPickupItem}
          title="Items Pickup Form"
          onCloseDialog={() => {
            this.setState({ openPickupItem: false });
          }}
          maxWIdth="md"
        >
          <ReservationItemsPickup
            warehouseID={warehouseID}
            onConfirmSave={() => {
              this.getReservationsData(
                salesOrderID,
                operationCardID,
                warehouseID,
                outletID,
                orderType
              );
              this.setState({ openPickupItem: false });
            }}
            onCloseDialog={() => {
              this.setState({ openPickupItem: false });
            }}
          />
        </DialogLayout>
      </React.Fragment>
    );
  }

  handleCloseDirectPickForm = () => {
    this.setState({ openDirectPickForm: false });
  };

  handleCancelItemsReservation = (rowData) => {
    const {
      salesOrderID = 0,
      operationCardID = 0,
      warehouseID = 0,
      outletID = 0,
      orderType = "-",
    } = this.props;
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Items Reservation ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelItemReservation(rowData.ID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            this.getReservationsData(
              salesOrderID,
              operationCardID,
              warehouseID,
              outletID,
              orderType
            );
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  };
}

export default withGlobalData(ItemsReservationList);
